import { useState } from 'react';
const C = { bg:'#080808',card:'#111',border:'#1a1a1a',green:'#00ff88',text:'#e2e8f0',muted:'#555' };
export default function AuthPage({ supabase, onBack }) {
  const [mode, setMode] = useState('signin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  async function handleSubmit(e) {
    e.preventDefault(); setLoading(true); setError(''); setSuccess('');
    try {
      if (mode === 'signup') {
        const { error } = await supabase.auth.signUp({ email, password, options: { data: { full_name: name } } });
        if (error) throw error;
        setSuccess('Check your email to confirm your account!');
      } else {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        window.location.href = '/';
      }
    } catch (err) { setError(err.message); } finally { setLoading(false); }
  }
  return (
    <div style={{ minHeight:'100vh', background:C.bg, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ width:'100%', maxWidth:420 }}>
        <button onClick={onBack} style={{ background:'none', border:'none', color:C.muted, cursor:'pointer', fontSize:14, marginBottom:20 }}>← Back</button>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <span style={{ fontSize:24, fontWeight:800 }}>⚡ <span style={{ color:'#fff' }}>KalshiBot</span> <span style={{ color:C.green }}>Pro</span></span>
        </div>
        <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:16, padding:32 }}>
          <div style={{ display:'flex', gap:8, marginBottom:28 }}>
            {['signin','signup'].map(m => (
              <button key={m} onClick={() => setMode(m)} style={{ flex:1, padding:'10px', borderRadius:8, border:'none', cursor:'pointer', fontWeight:600, fontSize:14, background: mode===m ? C.green : '#1a1a1a', color: mode===m ? '#000' : C.muted }}>
                {m === 'signin' ? 'Sign In' : 'Sign Up'}
              </button>
            ))}
          </div>
          {error && <div style={{ background:'rgba(255,80,80,0.1)', border:'1px solid rgba(255,80,80,0.3)', borderRadius:8, padding:'12px 16px', color:'#ff8080', fontSize:14, marginBottom:16 }}>{error}</div>}
          {success && <div style={{ background:'rgba(0,255,136,0.1)', border:'1px solid rgba(0,255,136,0.3)', borderRadius:8, padding:'12px 16px', color:C.green, fontSize:14, marginBottom:16 }}>{success}</div>}
          <form onSubmit={handleSubmit}>
            {mode === 'signup' && (
              <div style={{ marginBottom:16 }}>
                <label style={{ color:C.muted, fontSize:12, display:'block', marginBottom:6 }}>Full Name</label>
                <input value={name} onChange={e=>setName(e.target.value)} placeholder="Your name" required style={{ width:'100%', background:'#1a1a1a', border:`1px solid ${C.border}`, borderRadius:8, padding:'12px 14px', color:C.text, fontSize:14, boxSizing:'border-box' }} />
              </div>
            )}
            <div style={{ marginBottom:16 }}>
              <label style={{ color:C.muted, fontSize:12, display:'block', marginBottom:6 }}>Email</label>
              <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@email.com" required style={{ width:'100%', background:'#1a1a1a', border:`1px solid ${C.border}`, borderRadius:8, padding:'12px 14px', color:C.text, fontSize:14, boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:24 }}>
              <label style={{ color:C.muted, fontSize:12, display:'block', marginBottom:6 }}>Password</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required style={{ width:'100%', background:'#1a1a1a', border:`1px solid ${C.border}`, borderRadius:8, padding:'12px 14px', color:C.text, fontSize:14, boxSizing:'border-box' }} />
            </div>
            <button type="submit" disabled={loading} style={{ width:'100%', background: loading ? '#333' : C.green, color:'#000', border:'none', borderRadius:8, padding:'14px', fontSize:15, fontWeight:700, cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Loading...' : mode === 'signin' ? 'Sign In' : 'Create Account'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
